import React from "react";
import "./fieldset.scss";
import CopyToClipboard from "../CopyToClipboard/CopyToClipboard";
import { isSubProcess, copySubprocessToClipboard } from "../../utilities";

const Fieldset = ({ title, pending, children, element }) => {
  const showCopyToClipboard = element?.tags
    ? element?.tags.some((tag) => tag === "copypaste")
    : false;

  return (
    <fieldset className="dcrform-fieldset">
      <legend className={pending ? "pending-label" : ""}>
        {title}
        {isSubProcess(element?.type) && showCopyToClipboard ? (
          <CopyToClipboard onCopy={() => copySubprocessToClipboard(element)} />
        ) : null}
      </legend>
      {children}
    </fieldset>
  );
};

export default Fieldset;
